import { cva } from 'class-variance-authority'

export const cardVariants = cva('appearance-none rounded-30 bg-transparent text-left', {
  variants: {
    background: {
      normal: 'bg-surface-base-normal',
      none: '',
    },
    border: {
      basic: 'border border-line-base-basic',
      none: '',
    },
    elevation: {
      none: '',
      low: 'shadow-bottom-05',
      raised: 'shadow-bottom-10',
    },
    padding: {
      card: 'p-card',
      none: '',
    },
    interactive: {
      true: `
        cursor-pointer transition-[background-color,box-shadow,filter] motion-color outline-none
        focus-visible:ring-3 focus-visible:ring-line-base-input-focus/50
      `,
      false: '',
    },
  },
  compoundVariants: [
    { background: 'normal', interactive: true, class: 'hover:bg-surface-base-hover' },
    { interactive: true, elevation: 'low', class: 'hover:shadow-bottom-10' },
    { interactive: true, elevation: 'raised', class: 'hover:shadow-bottom-20' },
  ],
  defaultVariants: { background: 'normal', border: 'basic', elevation: 'low', padding: 'card', interactive: false },
})
